module.exports = __webpack_public_path__ + "img/zrdl.7edf5e2a.png";